import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { toCurrency, mapState } from '@deerplusofficial/pos-helper';
import InfoSectionWrapper from '../Info/InfoSectionWrapper';
import InfoSectionPoints from '../Info/InfoSectionPoints';
import InfoSection from '../Info/InfoSection';
import Info from '../Info/Info';
import MemberActions from '../MemberActions/MemberActions';
import TabContent from './TabContent';

class SideInfoContainer extends PureComponent {
  render() {
    const {
      children,
      order: { price, points },
    } = this.props;

    return (
      <TabContent>
        <InfoSectionWrapper>
          <InfoSectionPoints />
          <InfoSection>
            <Info label="支付金額">{toCurrency(price - points)}</Info>
          </InfoSection>
          <MemberActions />
        </InfoSectionWrapper>
        {children}
      </TabContent>
    );
  }
}

export default connect(mapState(['order']))(SideInfoContainer);



// WEBPACK FOOTER //
// ./src/components/CheckoutPanel/SideInfoContainer.js